import { render, staticRenderFns } from "./StaffQuestionnaire.vue?vue&type=template&id=40ec21a0&scoped=true&"
import script from "./StaffQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./StaffQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./StaffQuestionnaire.vue?vue&type=style&index=0&id=40ec21a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec21a0",
  null
  
)

export default component.exports